import { validateAcls } from '@redviking/argonaut-core-ui/src/auth';
import type { RouteConfig } from 'vue-router';
import {
    entityDetailRoute,
} from '@redviking/argonaut-core-ui/src/components/EntityDetail/entity-route-util';
import { accessor } from '@redviking/argonaut-core-ui/src/store';
import {
    generalTabRoute as generalTabRouteDeployment,
    jsonTabRoute,
    paramsTabRoute as paramsTabRouteDeployment,
    sparkplugTabRoute,
} from './util/consts';
import {
    getAppletDeploymentVersion,
    saveAppletDeploymentVersionEntity,
} from './appletDeployment.entity';
import RouteEntityDetail from '@redviking/argonaut-core-ui/src/components/EntityDetail/RouteEntityDetail.view.vue';

export const appletDeploymentRoute: RouteConfig = entityDetailRoute<'appletDeployment'>({
    path: 'deployment/:appletDeploymentId',
    name: 'appletDeployment',
    component: RouteEntityDetail,
    redirect: to => ({ name: generalTabRouteDeployment, params: to.params }),
    meta: {
        pageBannerTitle: () => {
            const deployment = accessor.entityAsType('appletDeployment')?.deployment;
            if (!deployment) {
                return 'Unknown Deployment';
            }
            const runnerId = deployment.runnerId;
            const deploymentName = deployment.name;
            return `${runnerId} > ${deploymentName}`;
        },
        returnRoute: { name: 'appletRunnerList' },
        canEdit: () => {
            return validateAcls([ 'applet_manager' ]);
        },
        entityType: 'appletDeployment',
        getEntity: getAppletDeploymentVersion,
        saveEntity: saveAppletDeploymentVersionEntity,
    },
    children: [
        {
            path: 'general',
            name: generalTabRouteDeployment,
            component: () => import(/* webpackChunkName: "appletDeployment" */ './General.tab.view.vue'),
            meta: {
                tab: {
                    label: 'General',
                    icon: 'mdi-note-text',
                },
            },
        },
        {
            path: 'params',
            name: paramsTabRouteDeployment,
            component: () => import(/* webpackChunkName: "appletDeployment" */ './Params.tab.view.vue'),
            meta: {
                tab: {
                    label: 'Parameters',
                    icon: 'mdi-cog',
                },
            },
        },
        {
            path: 'sparkplug',
            name: sparkplugTabRoute,
            component: () => import(/* webpackChunkName: "appletDeployment" */ './Sparkplug.tab.view.vue'),
            meta: {
                tab: {
                    label: 'Sparkplug',
                    icon: 'mdi-flash',
                },
            },
        },
        {
            path: 'json',
            name: jsonTabRoute,
            component: () => import(/* webpackChunkName: "appletDeployment" */ './Json.tab.view.vue'),
            meta: {
                tab: {
                    label: 'JSON',
                    icon: 'mdi-code-braces',
                },
            },
        },
    ],
});
